module.exports = __webpack_public_path__ + "6ab142368618d44bc69b241b58b8aad0.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/text@2x.png
// module id = 611
// module chunks = 0